namespace GeniuzPOS.InitialData {
    export interface PsExchangeRateForm {
        CurrencyCode: Serenity.LookupEditor;
        EffectiveDate: Serenity.DateEditor;
        ExchangeRate: Serenity.DecimalEditor;
    }

    export class PsExchangeRateForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsExchangeRate';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsExchangeRateForm.init)  {
                PsExchangeRateForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DateEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(PsExchangeRateForm, [
                    'CurrencyCode', w0,
                    'EffectiveDate', w1,
                    'ExchangeRate', w2
                ]);
            }
        }
    }
}
